import { FC, ReactNode } from 'react';
import './Promo.scss';

export const Promo: FC<{ children: ReactNode }> = ({ children }) => {
	return <div className="promo flex justify-between items-center">{children}</div>;
};
